module.exports = __webpack_public_path__ + "img/资源 28.69b8ce38.png";